import React, { InputHTMLAttributes, ReactNode, forwardRef } from 'react';
import styles from './Input.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  helperText?: string;
  fullWidth?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      error,
      icon,
      iconPosition = 'left',
      helperText,
      fullWidth = false,
      className = '',
      ...props
    },
    ref
  ) => {
    const containerClasses = [styles.container, fullWidth && styles.fullWidth, className]
      .filter(Boolean)
      .join(' ');

    const inputClasses = [
      styles.input,
      icon && iconPosition === 'left' && styles.hasIconLeft,
      icon && iconPosition === 'right' && styles.hasIconRight,
      error && styles.error,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <div className={containerClasses}>
        {label && (
          <label className={styles.label}>
            {label}
            {props.required && <span className={styles.required}>*</span>}
          </label>
        )}

        <div className={styles.inputWrapper}>
          {icon && iconPosition === 'left' && <span className={styles.iconLeft}>{icon}</span>}

          <input ref={ref} className={inputClasses} {...props} />

          {icon && iconPosition === 'right' && <span className={styles.iconRight}>{icon}</span>}
        </div>

        {error && <span className={styles.errorText}>{error}</span>}
        {!error && helperText && <span className={styles.helperText}>{helperText}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;